import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import {
  AnonymousConsentManagementBannerModule,
  AnonymousConsentOpenDialogComponent,
  AnonymousConsentsDialogModule,
  CategoryNavigationModule,
  NavigationModule,
  ScrollToTopModule,
} from '@spartacus/storefront';
import { RouterModule } from '@angular/router';
import { AnonymousConsentsModule, UrlModule } from '@spartacus/core';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';

@NgModule({
  declarations: [FooterComponent, TermsConditionsComponent],
  imports: [
    CommonModule,
    NavigationModule,
    ScrollToTopModule,
    CategoryNavigationModule,
    RouterModule,
    UrlModule,
    AnonymousConsentManagementBannerModule,
  ],
})
export class ComponentesModule {}
